import ValidateContactModal from './ValidateContactModal';

export default ValidateContactModal;
